import { useMediaQuery, useTheme } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

import { userInstrumentsSlice } from '!core/redux';
import { getError } from '!core/redux/userInstruments/userInstruments.selectors';
import { ButtonRefresh, ButtonUser } from '»components/atoms';
import {
  TrlAccountInfo,
  TrlFeedbackModal,
  TrlSearchBar,
  TrlUserInfo,
} from '»components/molecules';
import { useCurrentPage } from '»utils/customHooks';

import {
  AppBarLeftStyled,
  AppBarRightStyled,
  AppBarWrapperStyled,
} from '../AppBar.styles';
import { AppBarPrivateMobile } from './Mobile';

export const AppBarPrivate = () => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('lg'));

  const favError = useSelector(getError);

  const handleCloseFeedbackModal = () => {
    dispatch(userInstrumentsSlice.actions.resetError());
  };

  const { isProofPreviewPage } = useCurrentPage();

  return (
    <div>
      {matches && !isProofPreviewPage && (
        <AppBarWrapperStyled isAuthenticated>
          <AppBarLeftStyled isAuthenticated>
            <TrlSearchBar />
          </AppBarLeftStyled>
          <TrlAccountInfo />
          <AppBarRightStyled isAuthenticated>
            <TrlUserInfo />
            <ButtonUser />
            <ButtonRefresh />
            <TrlFeedbackModal
              title={{ content: 'TRLT_UI-ERROR' }}
              descr={{ content: favError }}
              type="warning"
              open={favError !== ''}
              onClose={handleCloseFeedbackModal}
            />
          </AppBarRightStyled>
        </AppBarWrapperStyled>
      )}
      {!matches && <AppBarPrivateMobile />}
    </div>
  );
};
